import Scorm2004API from '../Scorm2004API';
import Scorm12API from '../Scorm12API';
import AICC from '../AICC';

window.Scorm12API = Scorm12API;
window.Scorm2004API = Scorm2004API;
window.AICC = AICC;
